module.exports = __webpack_public_path__ + "img/tag-address.e2d4b405.svg";